<div
  class="my-6 flex flex-column align-items-center justify-content-center flex-wrap gap-4"
>
  <p-message severity="contrast" styleClass="border-round-3xl px-1">{{
    'NOT_FOUND_PAGE.ERROR_CODE' | translate
  }}</p-message>

  <span class="text-6xl font-bold">
    {{ 'NOT_FOUND_PAGE.WARNING' | translate }}
  </span>

  <span class="text-2xl font-medium">
    {{ 'NOT_FOUND_PAGE.TITLE' | translate }}
  </span>

  <p-button
    styleClass="border-round-3xl px-3"
    [label]="'NOT_FOUND_PAGE.REDIRECT_BUTTON' | translate"
    routerLink="/"
  />
</div>
